import './contacts.css';
import { ContactFormClass } from "../../components/widgets/contacts-section/contacts";
import { Header } from "../../components/widgets/header/header";
import { smoothScroll } from "../index/smooth-scroll";

export function initContactsPage() {
  Header.init();
  smoothScroll.init();
  const ContactForm = new ContactFormClass();
}